import { apiClient } from '@/lib/api/client'
import type { FamilyDto } from './types'

export async function getCatalogFamilies(projectId: string): Promise<FamilyDto[]> {
  return await apiClient.get<FamilyDto[]>(`/${projectId}/catalog/families`)
}
